// extracted by mini-css-extract-plugin
export default {"terms_services":"TermServices_terms_services__oy3fX","heading":"TermServices_heading__d5Mcr","bckbtn":"TermServices_bckbtn__IkC+s"};